import React, {useEffect, useRef, useState} from "react";
import styles from "./UIMessageVideo.module.scss";
import playImg from "../images/playImg.png";
import noVideo from "../images/no-video.png";
import {getUrl} from "src/service/files.service";
import {checkEmpty} from "src/utils/janus.utils";

function UIMessageVideo(props) {
  const {
    handlePreviewFile,
    isAnother,
    messageDetails,
    messageURLlocal,
    tempMsgId,
    uploadProgress,
    setUploadProgress,
    msgObj,
  } = props;
  const [isLoaded, setLoaded] = useState(false);
  const refProgress = useRef(false);
  const refLoadingProgress = useRef(false);
  const [isShowPlayBtn, setIsShowBtn] = useState(true);
  const videoDetailsLocal = messageURLlocal?.videoDetails?.[0];
  let videoDetails = null;
  if (messageDetails?.videoDetails) {
    videoDetails = messageDetails?.videoDetails?.[0];
  } else if (messageDetails?.fileDetails) {
    videoDetails = messageDetails?.fileDetails?.[0];
  }
  let percent = {};
  const fileServiceDownloadURL =
    window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/downloadFile?fileId=";

  const onError = (event) => {
    if (!videoDetailsLocal && !checkEmpty(urlvideo)) {
      event.target.classList.add(styles.hasError);
      event.target.src = noVideo;
      setIsShowBtn(false);
    }
  };

  useEffect(() => {
    if (!videoDetails?.id && uploadProgress?.length === 0)
      refLoadingProgress.current.style.display = "block";
    if (!videoDetails?.id && uploadProgress?.length > 0) {
      if (
        uploadProgress?.filter((item) => item?.tempMsgId === tempMsgId).length >
        0
      ) {
        percent = uploadProgress?.filter(
          (item) => item?.tempMsgId === tempMsgId
        )?.[0];
        refProgress.current.style.width = percent?.progress + "%";
      }
    }
    if (videoDetails?.id) refLoadingProgress.current.style.display = "none";
  }, [uploadProgress, isLoaded, videoDetails]);

  useEffect(() => {
    checkGetUrlFile();
  }, []);
  const [urlvideo, setUrlvideo] = useState("");
  const checkGetUrlFile = async () => {
    let url = fileServiceDownloadURL + videoDetails?.id + "&size=1024";
    if (videoDetails?.id)
      url = await getUrl(url, videoDetails?.id, 1024, "chat");
    setUrlvideo(url);
  };

  return (
    <div
      className={isAnother > 1 ? styles.msgStyleVideo2 : styles.msgStyleVideo1}
    >
      <div className={isAnother > 1 ? styles.openGraph2 : styles.openGraph1}>
        {videoDetails && (
          <div className={styles.linkVideo}>
            <div
              className={styles.previewImg}
              onClick={() => {
                if (isShowPlayBtn) {
                  handlePreviewFile(
                    "video",
                    videoDetails?.fileName,
                    videoDetails?.id,
                    "",
                    videoDetailsLocal || videoDetails,
                    msgObj
                  );
                }
              }}
            >
              {videoDetails?.id && (
                <img
                  src={urlvideo}
                  style={{
                    maxWidth: "240px",
                    height: "auto",
                    borderRadius: "10px",
                    display: videoDetails?.id && isLoaded ? "block" : "none",
                  }}
                  alt=""
                  onLoad={() => setLoaded(true)}
                  onError={onError}
                />
              )}

              <div
                className={styles.myProgress}
                style={{
                  display: videoDetails?.id && isLoaded ? "none" : "block",
                }}
              >
                <video
                  src={videoDetailsLocal}
                  style={{
                    maxWidth: "240px",
                    maxHeight: "240px",
                    borderRadius: "10px",
                  }}
                ></video>
                <div ref={refLoadingProgress} className={styles.videoProgress}>
                  <div ref={refProgress} className={styles.myBar}></div>
                </div>
              </div>

              {isShowPlayBtn && (
                <div className={styles.playImg}>
                  <div
                    style={{
                      width: "70px",
                      height: "70px",
                      borderRadius: "50%",
                      backgroundPosition: "0px center",
                      backgroundImage: `url(${playImg})`,
                      backgroundSize: "cover",
                      margin: "auto",
                    }}
                  ></div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default React.memo(UIMessageVideo);
